/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import csgroupLogo from '@/assets/img/csgroup-logo.svg';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export const CopyRightFooter: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <footer className={`${className ?? ''} w-full flex-shrink-0`} style={{ padding: 'var(--site-padding-x)' }}>
      <Divider layout="horizontal" />
      <div className="flex align-items-center justify-content-between gap-3 text-sm text-color-secondary">
        <div className="flex  gap-2">
          <div className="font-semibold">CS Group Copyright © {new Date().getFullYear()}</div>
          <a
            href="https://www.cs-soprasteria.com/"
            style={{ display: 'flex', alignItems: 'flex-end' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={csgroupLogo} height={18} alt="CS Group Logo" />
          </a>
        </div>
        <div className="font-semibold">{t(['misc.powered_by', 'Powered by CS Group '])}</div>
      </div>
    </footer>
  );
};
